import { Component, OnInit, NgZone, } from '@angular/core';
import { FormGroup, FormBuilder, Validators, FormArray } from '@angular/forms';
import { environment } from '../../../../../environments/environment';
import { AuthservicesService } from '../../../../services/authservices.service';
import { Router } from '@angular/router';
@Component({
  selector: 'app-create-post',
  templateUrl: './create-post.component.html',
  styleUrls: ['./create-post.component.css']
})
export class CreatePostComponent implements OnInit {
  form: FormGroup;
  submitted = false
  currentUser
  communityData
  loading = false
  coverPhoto
  accessibility
  obj = {}
  errorMessage

  constructor(private authService: AuthservicesService, private fb: FormBuilder, private router: Router) {
  }
  ngOnInit(): void {
    this.errorMessage = environment.errorMessage

    this.accessibility = environment.Accessibilities
    this.currentUser = JSON.parse(localStorage.getItem('ministry_currentUser'))
    this.getCommunityId(this.currentUser);

    this.form = this.fb.group({
      text: ['', Validators.required],
      image: [''],
      accessibility: ['', Validators.required],

    })
  }


  get f() {
    return this.form.controls;
  }

  getCommunityId(data) {
    let id
    if (data) {
      id = this.currentUser.id
    }

    this.authService.getCommunityByid(id).subscribe((res: any) => {
      this.loading = true
      this.communityData = res.data;

      this.obj = {
        name: (this.communityData.name ? this.communityData.name : ''),
        photo: (this.communityData.photo) ? this.communityData.photo : '',
      }
    },
      error => {
        console.log(error)
      })
  }

  renderImage(image) {
   let imgUrl= this.authService.spilturl(image);
   return imgUrl
  }

  uploadBanner(event) {
    if (event.target.files.length > 0) {
      const file = event.target.files[0];
      const formData = new FormData();
      console.log(formData, 'testing')
      formData.append('image', file, file.name);
      formData.append('imageType', 'postImage');
      this.authService
        .upload(formData)
        .subscribe(
          data => {
            this.coverPhoto = environment.basePath + data['data'].url;
            this.form.get('image').setValue(this.coverPhoto)
          },
          error => {
            this.authService.successMessage(error.error.message, 'error')

          }
        );
    } else {
      this.authService.successMessage('Error', 'error')

    }
  }
  onSubmit() {
    this.submitted = true;
    if (this.form.invalid) {
      this.authService.scrollToError();
      return;
    }
    this.authService.createPost(this.form.value).subscribe((res: any) => {
      this.authService.successMessage(res.message, 'success')
      this.router.navigate(['/social-feed'])
    },
      error => {
        this.authService.successMessage(error.error.message, 'error')
      })
  }


}




